export default __webpack_public_path__ + "static/media/head03_en_sp.0c1365f9.png";